/**
 * The one toast function every screen is handed.
 *
 * It was written out identically at six mount sites before it moved into
 * `main.js`, and it moved out of `main.js` on 22 Aug 2026 when the composition
 * root ran out of its 400-line budget. It is the right shape for `lib/`: no
 * feature owns it, and everything that mounts a screen needs it.
 *
 * ── Why it reaches for a global ───────────────────────────────────────────
 *
 * `showToast` is `app.html`'s (app.html:14322), and during the transition a
 * `/v2` screen can be running inside either program. Rather than ship a second
 * toast implementation that looks slightly different from the one already on
 * the page, this asks for the one that is there — and says its piece to the
 * console when nothing is, so a message is never simply lost.
 */

/**
 * @param {string} message
 * @param {string} [tone] - accepted and forwarded; the legacy toast reads
 *   'success' | 'error' | 'warning' | 'info' and defaults to a neutral note
 */
export function toast(message, tone) {
  const show = /** @type {any} */ (globalThis).showToast
  if (typeof show === 'function') show(message, tone)
  else console.warn(message)
}
